module.exports = __webpack_public_path__ + "img/IMG-20191212-WA0043.75678176.jpg";